import ActivityDataCard from './activityDataCard.js';
export default ActivityDataCard;
